import React from 'react';
import FaqJSX from './FaqJSX';

interface Questions {
  title: string,
  questions: {
    title:string,
    answer:string,
    links:string,
    is_blog:boolean
  }[],
  className?:string,
  page_url?:string,
  category?:any,
  pineLabs?: boolean
}

class Faq extends React.Component<Questions> {
  render() {
    return <FaqJSX title={this.props.title || ''} questions={this.props.questions || []} className={this.props.className} page_url={this.props.page_url} category={this.props.category} pineLabs={this.props.pineLabs}/>
  }
}

export default Faq
